module.exports = __webpack_public_path__ + "img/page.845d90e9.png";